import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles.scss'

const GenericStatusLoading = ({ extraClassName }) => (
  <div className={`${extraClassName} ${styles.loader__wrapper}`}>
    <div className={styles.loader}>Loading...</div>
  </div>
)

GenericStatusLoading.defaultProps = {
  extraClassName: '',
}

GenericStatusLoading.propTypes = {
  extraClassName: PropTypes.string,
}

export default GenericStatusLoading



// WEBPACK FOOTER //
// ./components/GenericStatusLoading/index.jsx